import { render } from "./SidebarCollapse.vue?vue&type=template&id=2992867c"
import script from "./SidebarCollapse.vue?vue&type=script&lang=js"
export * from "./SidebarCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/home/foderboxen/admin.foderboxen.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__